import { useMemo } from "react";
import { useTriviaContext } from "../context-trivia";
import { TriviaAnswerGrid } from "../TriviaAnswerGrid/TriviaAnswerGrid";
import { TriviaQuestionHelp } from "./TriviaQuestionHelp";
import { TriviaQuestionMedia } from "./TriviaQuestionMedia";
import { TriviaTimer } from "./TriviaTimer";

export function TriviaQuestion() {
  const { config, currentQuestion, machine, submitAnswer, submitTimeout } =
    useTriviaContext();

  const hiddenAnswerIds = useMemo(() => {
    if (!currentQuestion || !machine.usedHelp.includes("fiftyFifty")) {
      return [];
    }

    const wrongAnswers = currentQuestion.answers.filter((a) => !a.correct);
    const toHide = Math.floor(currentQuestion.answers.length / 2);

    return wrongAnswers.slice(0, toHide).map((a) => a.id);
  }, [currentQuestion, machine.usedHelp]);

  if (!currentQuestion) {
    return null;
  }

  const timeLimit = currentQuestion.timeLimit ?? config.timer.seconds;
  const locked = !!machine.submittedQuestionId;
  const selectedAnswerId = machine.selections.find(
    (s) => s.questionId === currentQuestion.id,
  )?.answerId;

  return (
    <div className="flex h-full min-h-0 w-full flex-col gap-[var(--trivia-space)]">
      <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-[var(--trivia-space)] overflow-x-hidden overflow-y-auto overscroll-contain px-[var(--trivia-space)]">
        <div
          className="hyphens-auto text-balance break-words text-center font-bold"
          style={{ fontSize: "var(--trivia-text-prompt)" }}
        >
          {currentQuestion.prompt}
        </div>
        <TriviaQuestionMedia
          media={currentQuestion.media}
          mediaAlt={currentQuestion.mediaAlt}
          caption={currentQuestion.mediaCaption}
        />
      </div>
      {config.timer.enabled && (
        <div className="w-full flex-none px-[var(--trivia-space)]">
          <TriviaTimer totalSeconds={timeLimit} onEnd={submitTimeout} />
        </div>
      )}
      <div className="min-h-0 flex-1">
        <TriviaAnswerGrid
          answers={currentQuestion.answers}
          hiddenAnswerIds={hiddenAnswerIds}
          disabled={locked}
          selectedAnswerId={selectedAnswerId}
          onSelect={submitAnswer}
        />
      </div>
      {config.help.enabled && config.help.fiftyFifty && (
        <div className="w-full flex-none px-[var(--trivia-space)]">
          <TriviaQuestionHelp />
        </div>
      )}
    </div>
  );
}
